import SubscriptionInfos from "./Plans/SubscriptionInfos";

export default function HistoryOfPackage() {
  return <SubscriptionInfos />;
}
